import classNames from 'classnames'
import ScrollHandler from '../ui/ScrollHandler/ScrollHandler'
import styles from './HeaderScrollHandler.module.scss'
function HeaderScrollHandler({
  subTitle,
  isAtEnd,
  isAtStart,
  scrollLeft,
  scrollRight,
  className,
  subTitleClass,
  avoidRtl,
}) {
  return (
    <div className={classNames(styles.container, className)}>
      <span className={classNames(styles.subTitle, subTitleClass)}>
        {subTitle}
      </span>
      {!(isAtStart && isAtEnd) && (
        <ScrollHandler
          scrollLeftHandler={scrollLeft}
          scrollRightHandler={scrollRight}
          isAtEnd={isAtEnd}
          isAtStart={isAtStart}
          avoidRtl={avoidRtl}
        />
      )}
    </div>
  )
}

export default HeaderScrollHandler
